import { render, staticRenderFns } from "./RpError.vue?vue&type=template&id=82d3d5a6&scoped=true&"
import script from "./RpError.vue?vue&type=script&lang=ts&"
export * from "./RpError.vue?vue&type=script&lang=ts&"
import style0 from "./RpError.vue?vue&type=style&index=0&id=82d3d5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d3d5a6",
  null
  
)

export default component.exports